<template>
  <VueContentLoading
    :primary="$scss.colors.cardBg"
    :secondary="$scss.colors.inputBg"
    :width="235"
    :height="500"
  >
    <rect x="0" y="10" rx="4" ry="4" width="75%" height="40"></rect>
    <rect x="0" y="80" rx="4" ry="4" width="100%" height="45"></rect>
    <rect x="0" y="133" rx="4" ry="4" width="100%" height="45"></rect>

    <!--stage info mask-->
    <rect x="0" y="210" rx="4" ry="4" width="60%" height="25"></rect>
    <rect x="0" y="251" rx="4" ry="4" width="100%" height="18"></rect>
    <rect x="0" y="278" rx="4" ry="4" width="100%" height="18"></rect>
    <rect x="0" y="305" rx="4" ry="4" width="100%" height="18"></rect>

    <rect x="0" y="355" rx="4" ry="4" width="60%" height="25"></rect>
    <rect x="0" y="396" rx="4" ry="4" width="100%" height="18"></rect>
    <rect x="0" y="423" rx="4" ry="4" width="100%" height="18"></rect>
    <rect x="0" y="450" rx="4" ry="4" width="100%" height="18"></rect>
  </VueContentLoading>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'StageSummaryLoader',
  components: {
    VueContentLoading,
  },
};
</script>
